import { ProfilesMap } from "../utils/Profiles.map"


export interface InitialProfile {
    compute: string
    bandwidth: string
    disk: string
}

const getInitialHardwareByQueryParam = (location: Location, paramName: string):string => {
    return new URLSearchParams(location.search).get(paramName)
}

export const getInitialImage = (location: Location): number => {
    return parseInt(getInitialHardwareByQueryParam(location, 'imagem') || '26')
}

export const getGroupQueryParam = (location: Location): string | null => {
    return new URLSearchParams(location.search).get('group')
}

export const getInitialHardware = (location: Location): InitialProfile => {
    const profile = parseInt(getInitialHardwareByQueryParam(location, 'profile') || '1')
    const profileMap = ProfilesMap[profile]
    return profileMap
}

export const getInitialCollapse = (location: Location): boolean => {
    const showConfig = getInitialHardwareByQueryParam(location, 'showConfig') || '0';
    return showConfig ? !!!parseInt(showConfig): false
}

